import Head from 'next/head'
import 'regenerator-runtime/runtime'
import { CREATE_SUB_MENU, ROUTES } from '../constants/navigation'
import { withHeaderOptions } from '../hoc/withHeaderOptions'
import { getPerenderedChallenges, getPrerenderedTemplates } from '../queries/create'
import { getPrerenderedInspirations } from '../queries/posts'
import Home from '../routes/Home'
import { addDisableOverscroll, addRouteType, addSecondaryMenu } from '../utils/navigation'

const Routes = ({ templates, challenges, userEvents, inspirations, isMobile }) => {
  return (
    <>
      <Head>
        <title>Room Design App & Interior Design Games | DecorMatters</title>
        <meta
          name="description"
          content="Design real rooms, play interior design games, explore millions of ideas, and create with AI — all in one home design app used by millions."
        />
        <meta name="twitter:title" content="Room Design App & Interior Design Games | DecorMatters" />
        <meta property="og:title" content="Room Design App & Interior Design Games | DecorMatters" />
        <meta name="twitter:description" content="Design real rooms, play interior design games, explore millions of ideas, and create with AI — all in one home design app used by millions." />
        <meta
          property="og:description"
          content="Design real rooms, play interior design games, explore millions of ideas, and create with AI — all in one home design app used by millions."
        />
        <meta property="og:site_name" content="DecorMatters" />
        <meta property="og:url" content="https://www.decormatters.com" />
        <link rel="canonical" href="https://www.decormatters.com" />
        <meta name="google-site-verification" content="tc8tm4ArNtKEDRKnlRcx3Yci9kajD8h5x1vtRdrbOM0" />
      </Head>
      <Home templates={templates} challenges={challenges} inspirations={inspirations} />
    </>
  )
}

export default withHeaderOptions(Routes)(addSecondaryMenu(CREATE_SUB_MENU), addRouteType(ROUTES.HOMEPAGE), addDisableOverscroll())

export async function getStaticProps() {
  try {
    const inspirations = await getPrerenderedInspirations()
    const templates = await getPrerenderedTemplates()
    const challenges = await getPerenderedChallenges()

    return {
      props: {
        inspirations: inspirations?.result?.userInspirations.slice(0, 10),
        templates: templates?.result?.templates,
        challenges: challenges?.result?.designContests,
        disableModals: true
      },
      revalidate: 3600
    }
  } catch (error) {
    console.log(error)
    return {
      props: {}
    }
  }
}
